import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteBroadcastParams {
  viewLuid: string;
}

export interface IDeleteBroadcastResult extends IResult {
}

export class DeleteBroadcastRequest extends Request<IDeleteBroadcastParams, IDeleteBroadcastResult> {
  constructor(params: IDeleteBroadcastParams) {
    super('deleteBroadcastView', params);
  }
}